import React from 'react';
import BN from 'bignumber.js';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import OmIcon from '../../../../../../../assets/images/tokens/om-v2.svg';
import Header from '../../../../../../../components/Stake/header';
import stylesParent from '../../../styles/frame/frame.module.scss';
import Tooltip from '../../../../../../../components/tooltip';
import {
  OM,
  SHORT_CLAIM_PERIOD,
  SHORT_CLAIM_PENALTY,
} from '../../../../../../../constants/blockchain-constants';
import stylesClaim from '../../../styles/claim/claim.module.scss';
import { formatToken } from '../../../../../../../helpers/token-helper';

const ShortClaim = ({ setStatus }) => {
  const dark = useSelector((state) => state.basic.dark);
  const unclaimedAmount = useSelector((state) => state.delegator.polkadot.unclaimedAmount);

  return (
    <>
      <Header onClickBack={() => setStatus(2)} icon={OmIcon} title={`${OM}-Claim`} />
      <div className={stylesClaim.body}>
        <div className={stylesClaim.title}>Short Claim</div>
        <div className={stylesClaim.description}>
          Short claimers are only able to{' '}
          <span>claim {Math.round((1 - SHORT_CLAIM_PENALTY) * 100)}%</span> of their accrued OM
          nominator rewards. The remaining {SHORT_CLAIM_PENALTY * 100}% are redistributed amongst
          longer term stakeholders in the MANTRA DAO ecosystem.
        </div>
        <div>
          <div className={stylesClaim.rowContainer}>
            <div className={stylesClaim.row}>
              <div className={stylesClaim.rowLabel}>
                <Tooltip label={`Unclaimed ${OM} Rewards`} />
              </div>
              <div className={stylesClaim.rowValue}>{formatToken(unclaimedAmount)} OM</div>
            </div>
            <div className={stylesClaim.row}>
              <div className={stylesClaim.rowLabel}>
                <Tooltip
                  label='Forfeited Rewards'
                  text={
                    <div className={stylesParent.tooltipText}>
                      Forfeited rewards are redistributed back to the Long Claimers and the native
                      OM Stakers.
                    </div>
                  }
                />
              </div>
              <div className={stylesClaim.rowValue}>-{SHORT_CLAIM_PENALTY * 100}%</div>
            </div>
          </div>
          <div className={stylesClaim.rowContainer}>
            <div className={stylesClaim.row}>
              <div className={stylesClaim.rowLabel}>
                <Tooltip label='Available OM Rewards to Claim' />
              </div>
              <div className={stylesClaim.rowValue}>
                <b>
                  {formatToken(new BN((1 - SHORT_CLAIM_PENALTY) * unclaimedAmount).toString(10))} OM
                </b>
              </div>
            </div>
            <div className={stylesClaim.row}>
              <div className={stylesClaim.rowLabel}>
                <Tooltip label='Claiming Period' />
              </div>
              <div className={stylesClaim.rowValue}>
                <b>{SHORT_CLAIM_PERIOD} Days</b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={cn(stylesParent.cardFooterControls, stylesParent.claim, {
          [stylesParent.dark]: dark,
        })}
      >
        <Button
          onClick={() => setStatus(7)}
          variant='contained'
          color='secondary'
          className={stylesParent.cardFooterControlsButton}
        >
          Next
        </Button>
      </div>
    </>
  );
};

ShortClaim.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default ShortClaim;
